var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "ul",
      { staticClass: "list found-chats" },
      _vm._l(_vm.items, function (chat, i) {
        return _c("chat-item", {
          key: i,
          attrs: {
            chat: chat,
            focused: _vm.focusOnItem === i,
            noSelection: true,
            isGroupsDefault: true,
          },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }